"use client";

import React from "react";
import { useGoogleDriveCache } from "@/lib/contexts/GoogleDriveCacheContext";
import { Badge } from "@wtc/ui";
import { Database, Zap } from "lucide-react";

export interface GoogleDriveCacheIndicatorProps {
  className?: string;
  showDetails?: boolean;
}

export function GoogleDriveCacheIndicator({
  className = "",
  showDetails = false,
}: GoogleDriveCacheIndicatorProps) {
  const cache = useGoogleDriveCache();
  const cacheInfo = cache.getCacheInfo();

  const activeEntries = cacheInfo.entries.filter((e) => e.expiresAt > Date.now()).length;
  const usagePercent = Math.round((cacheInfo.size / cacheInfo.maxSize) * 100);

  if (!showDetails) {
    return (
      <Badge variant="outline" className={`text-xs ${className}`}>
        <Database className="h-3 w-3 mr-1" />
        {cacheInfo.size} cached
      </Badge>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Badge variant="outline" className="text-xs">
        <Database className="h-3 w-3 mr-1" />
        {cacheInfo.size}/{cacheInfo.maxSize}
      </Badge>
      <Badge variant="outline" className="text-xs">
        <Zap className="h-3 w-3 mr-1" />
        {activeEntries} active
      </Badge>
      <Badge
        variant={usagePercent > 80 ? "destructive" : usagePercent > 60 ? "secondary" : "outline"}
        className="text-xs"
      >
        {usagePercent}% used
      </Badge>
    </div>
  );
}
